import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Openingbalances} from '../openingbalances';
import {OpeningbalancesService} from '../openingbalances.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message, SelectItem} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule} from "primeng/primeng";
import {Http, RequestOptions, ResponseContentType} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ItemsGroupsShowComponent} from "../../../setting/itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CurrenciesShowComponent} from "../../../setting/currencies/currencies-show/currencies-show.component";
import {formatDate} from "ngx-bootstrap/chronos";
import {CustomerService} from "../../../setting/customers/customer.service";
import {ItemService} from "../../../setting/items/items.service";
import {AccountsService} from "../../accounts/accounts.service";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {AccountsShowComponent} from '../../accounts/accounts-show/accounts-show.component';

@NgModule({
  imports: [CommonModule, FormsModule, DropdownModule, MyInputsModule,
    ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
  ],
  declarations: [
    OpeningbalancesShowComponent
  ],
  entryComponents: [
    OpeningbalancesShowComponent
  ],
  exports: [],
  providers: [SharedService, OpeningbalancesService, MessageService, ConfirmationService, AccountsService],
  schemas: [NO_ERRORS_SCHEMA]
})

@Component({
  selector: 'app-invoices-show',
  templateUrl: './openingbalances-show.component.html',
  styleUrls: ['./openingbalances-show.component.scss'],
  providers: [OpeningbalancesService, ConfirmationService, MessageService, CustomerService, ItemService, AccountsService]
})

export class OpeningbalancesShowComponent implements OnInit, AfterViewInit {
  id: string;
  invoice: Openingbalances= new Openingbalances();
  @Input() refShow;
  bank: any[] = [];
  restoreInv: any;
  applog: AppLogComponent;
  parent_name: any;
  @Input() scrId;
  modalRef: NgbModalRef;
  parent: any;

  @Input() modelName;
  @Input() delId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;

  statusVal = ['','Manual','Automatic'];
  defVal = [{'val': 1, 'title': 'Yes'}, {'val': 0, 'title': 'No'}];
  typeVal = [{'val': 1, 'title': 'Other'}, {'val': 3, 'title': 'refunds'}, {'val': 4, 'title': 'Invoices'}];
  docTypes = [
    {'val':1,'title':'Other'},
    {'val':2,'title':'Purchases'},
    {'val':3,'title':'Purchases Return'},
    {'val':4,'title':'Invoice'},
    {'val':5,'title':'Invoice Return'},
    {'val':6,'title':'Reciept Voucher'},
    {'val':7,'title':'Expense Voucher'}
  ];
  allinvdetails: any[] = [];
  today = formatDate(new Date(), "YYYY-MM-DD");

  Selectedpaymentway: any = 0;
  Selectedpaymentdetails: any = "";
  Selectedpaymentamount: any = 0;

  total_credit = 0.0;
  total_debit = 0.0;
  total_credit_old = 0.0;
  total_debit_old = 0.0;
  allcost_a_tax: any = 0;
  alltaxes: any = 0;
  allcostsforone: any = 0;
  alldiscountvalue: any = 0;

  Selecteditem: any;
  Selecteditemcost: any = 0.0;
  Selecteditemquty: any = 0.0;
  Selecteditemtotal_b_tax: any;
  Selecteditemtotal_a_tax: any;
  Selecteditemtax: any;
  Selecteditemdetails: any;

  itemCount: any[] = [];
  itemCount_old: any[] = [];
  itemCountPayment: any[] = [];


  invoice_arr: any[] = [];
  invoice_list_arr: any[] = [];
  invoice_payment_arr: any[] = [];


  deletedrow: any[] = [];
  deletedrowPayment: any[] = [];
  selectedrow: any[] = [];

  customers: any[] = [];
  customersselected: any[] = [];

  Selected_items: any[] = [];
  Selected_items_old: any[] = [];
  Selected_payment: any[] = [];
  items: SelectItem[] = [];
  Selected_items_db: string[] = [];
  selectedItem: string[] = [];
  selectedItem_old: string[] = [];
  selectedPayment: string[] = [];

  allitems: any = [];
  items_enhance: any = [];
  payment_enhance: any = [];
  //invoice_typeVal = [{'val': 1, 'title': 'نقدية'}, {'val': 2, 'title': 'آجلة'}];
  invoice_typeVal: any;
  showDocNo = 1;
  cities: any[] = [];

  currency: any[] = [];
  docs: any[] = [];
  form: FormGroup;
  private sub: any;
  msgs: Message[] = [];
  public imgUrl = appConfig.publicUrl;
  private _editButton: any;
  private _deleteButton: any;
  private _newButton: any;
  private _printButton: any;
  private _searchButton: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private sharedservice: SharedService,
              private invoiceService: OpeningbalancesService,
              private accountsService: AccountsService,
              private modalService: NgbModal,
              public activeModal: NgbActiveModal,
              private customerservice: CustomerService,
              private itemservice: ItemService,
              public translate: TranslateService,
              private confirmationService: ConfirmationService,
              private messageService: MessageService) {
    const userdata = JSON.parse(localStorage.getItem('currentUser'));

    if (userdata && userdata.lang) {
      this.translate.use(userdata.lang);
    }
    this.sharedservice.setTitle(this.route.snapshot.data.title);
    this.sharedservice.setItemShow(OpeningbalancesShowComponent);
    this.sharedservice.setButtons([
      {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
      {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
      {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
      // {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
      {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

    ]);
    this.sharedservice.setModelName('openingbalances');


    this.accountsService.getAllGroups().subscribe(
      group => {
        this.allinvdetails = group;
      });

  }

  recordData() {
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        // this.changePicUrl();
        return true;
      }
    };
    const modalRef = this.modalService.open(RecordDataComponent, options);
    modalRef.componentInstance.refRec = this.invoice;
    modalRef.componentInstance.rowId = '';

  }

  ngAfterViewInit() {
    if(!this.scrId && !this.newData) {
      this._editButton = document.getElementById('editButton');
      this._deleteButton = document.getElementById('deleteButton');
      this._printButton = document.getElementById('printButton');
      this._searchButton = document.getElementById('searchButton');


      if (this._editButton) {
        this._editButton.onclick = ((e: any) => {
          e.preventDefault();
          this.router.navigate(['/openingbalances/edit', this.id]);
        });
      }

      if (this._deleteButton) {

        this._deleteButton.onclick = ((e: any) => {
          e.preventDefault();
          this.deleteOpeningbalances(this.invoice);
        });
      }

      if (this._searchButton) {
        this._searchButton.onclick = ((e: any) => {
          e.preventDefault();
          this.router.navigate(['/openingbalances/search']);
        });

      }

      if (this._printButton) {
        this._printButton.onclick = ((e: any) => {
          e.preventDefault();
          this.print();
        });

      }
    }
  }

  print() {
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    const tokenapi = userdata.api_token;
    const options = new RequestOptions({responseType: ResponseContentType.Blob });
    window.open(appConfig.apiUrl + 'openingbalances/print/'+this.id+'?token='+ tokenapi )
  }

  loaddocs(i) {
    if(this.Selected_items[i].document_type === 1) {
      this.docs[this.Selected_items[i].document_type] = [];
    } else if(typeof  this.docs[this.Selected_items[i].document_type] === 'undefined' || this.docs[this.Selected_items[i].document_type].length === 0 ) {
      this.accountsService.getDocs(this.Selected_items[i].document_type).subscribe(list => {
        this.docs[this.Selected_items[i].document_type] = list;
      });
    }
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];

    });

    this.form = new FormGroup({
      id: new FormControl({value: '', disabled: true}),

      action_year: new FormControl({value: '', disabled: true})

    });

    if(this.id) {
      this.activeModal.dismiss('');
      this.oldData = false;
      this.newData = false;
      this.delId = false;
      this.newDatap = true;
      localStorage.removeItem('filter');
      localStorage.removeItem('summ');
      const msg = JSON.parse(localStorage.getItem('showMessages'));
      if (msg) {
        localStorage.removeItem('showMessages');
        this.msgs = msg;
      }


      this.invoiceService.getById(this.id).subscribe(
        invoice => {
          this.invoice_arr = invoice.invoice;
          this.invoice_list_arr = invoice.itemsdetails;
          this.selectedItem = invoice.selecteditems;

          this.id = invoice.invoice.id;
          this.invoice = invoice.invoice;
          this.form.patchValue({
            id: invoice.invoice.id,
            action_year: invoice.invoice.action_year
          });

          for (let i = 0; i < this.invoice_list_arr.length; i++) {
            let iserte = {
              value: this.invoice_list_arr[i].account_no, inx: i ,
              statement:this.invoice_list_arr[i].statement ,
              action_year:this.invoice_list_arr[i].action_year ,
              cost_center_id:this.invoice_list_arr[i].cost_center_id ,
              document_type:this.invoice_list_arr[i].document_type ,
              document_no:this.invoice_list_arr[i].document_no ,
              credit:this.invoice_list_arr[i].credit ,
              debit:this.invoice_list_arr[i].debit
            };
            this.Selected_items[i] = iserte;
            this.loaddocs(i);
          }
          this.itemCount = Array(this.Selected_items.length).fill(2);
          this.changeallremain();
        }, error => {
          console.log(error);
        }
      );

    }
    if(this.scrId) {
      this.oldData = false;
      this.newData = false;
      this.delId = false;

      this.invoiceService.getById(this.id).subscribe(
        invoice => {
          this.invoice_arr = invoice.invoice;
          this.invoice_list_arr = invoice.itemsdetails;
          this.invoice_payment_arr = invoice.itemspayment;
          this.selectedItem = invoice.selecteditems;

          this.id = invoice.invoice.id;
          this.invoice = invoice.invoice;
          this.form.patchValue({
            document_type: invoice.invoice.document_type,
            date_time: invoice.invoice.date_time,
            recipient_name: invoice.invoice.recipient_name,
            document_no: invoice.invoice.document_no,
            statement: invoice.invoice.statement

          });

          if (invoice.invoice.invoice_type == 1) {
            this.invoice_typeVal = "نقدية";

          } else {
            this.invoice_typeVal = "آجلة";
          }

          this.customersselected = [this.customers[invoice.invoice.customer_id]];


          for (let i = 0; i < this.invoice_list_arr.length; i++) {
            let iserte = {
              value: this.invoice_list_arr[i].item_id,
              inx: i,
              cost: (this.invoice_list_arr[i].cost_before_tax / this.invoice_list_arr[i].quantity),
              qty: this.invoice_list_arr[i].quantity,
              totalBtax: this.invoice_list_arr[i].cost_before_tax,
              taxvalue: this.invoice_list_arr[i].tax_ammount,
              totalAtax: this.invoice_list_arr[i].cost_after_tax,
              itemdetails: this.invoice_list_arr[i].details
            };
            this.Selected_items[i] = iserte;
          }
          this.itemCount = Array(this.Selected_items.length).fill(2);

          for (let i = 0; i < this.invoice_payment_arr.length; i++) {

            let iserte = {
              payment_type: this.invoice_payment_arr[i].payment_type,
              payment_details: this.invoice_payment_arr[i].payment_details,
              payment_amount: this.invoice_payment_arr[i].amount
            };
            ;
            this.Selected_payment[i] = iserte;
          }
          this.itemCountPayment = Array(this.invoice_payment_arr.length).fill(2);
          this.changeallremain();
        }, error => {
          console.log(error);
        }
      );


    }
    if(this.delId){
      this.oldData = false;
      this.newData = false;
      this.newDatap = !this.newDatap ;
      this.invoiceService.getTrashedById(this.delId).subscribe(
        invoice => {
          this.invoice_arr = invoice.invoice;
          this.invoice_list_arr = invoice.itemsdetails;
          this.invoice_payment_arr = invoice.itemspayment;
          this.selectedItem = invoice.selecteditems;

          this.id = invoice.invoice.id;
          this.invoice = invoice.invoice;

          this.form.patchValue({
            id: invoice.invoice.id,
            action_year: invoice.invoice.action_year,

          });

          if (invoice.invoice.invoice_type == 1) {
            this.invoice_typeVal = "نقدية";

          } else {
            this.invoice_typeVal = "آجلة";
          }

          for (let i = 0; i < this.invoice_list_arr.length; i++) {
            let iserte = {
              value: this.invoice_list_arr[i].account_no, inx: i ,
              statement:this.invoice_list_arr[i].statement ,
              action_year:this.invoice_list_arr[i].action_year ,
              cost_center_id:this.invoice_list_arr[i].cost_center_id ,
              document_type:this.invoice_list_arr[i].document_type ,
              document_no:this.invoice_list_arr[i].document_no ,
              credit:this.invoice_list_arr[i].credit ,
              debit:this.invoice_list_arr[i].debit
            };
            this.Selected_items[i] = iserte;
          }
          this.itemCount = Array(this.Selected_items.length).fill(2);

          this.changeallremain();


        }, error => {
          console.log(error);
        }
      );
    }

    if(this.oldData && this.newData){
      this.invoice = this.newData;
      this.selectedItem_old = this.oldData.selecteditems;
    
      this.form.patchValue({
        id: this.newData.invoice.id,
        document_type: this.newData.invoice.document_type,
        action_year: this.newData.invoice.action_year,
        recipient_name: this.newData.invoice.recipient_name,
        document_no: this.newData.invoice.document_no,
        statement: this.newData.invoice.statement,
      });
      let invoice_list_arr_new = this.newData.itemsdetails,
          invoice_list_arr_old = this.oldData.itemsdetails;

      for (let i = 0; i < invoice_list_arr_old.length; i++) {
        let iserte = {
          value: invoice_list_arr_old[i].account_no, inx: i ,
          statement:invoice_list_arr_old[i].statement ,
          action_year:invoice_list_arr_old[i].action_year ,
          cost_center_id:invoice_list_arr_old[i].cost_center_id ,
          document_type:invoice_list_arr_old[i].document_type ,
          document_no:invoice_list_arr_old[i].document_no ,
          credit:invoice_list_arr_old[i].credit ,
          debit:invoice_list_arr_old[i].debit
        };
        this.Selected_items_old[i] = iserte;
      }
      this.restoreInv = this.oldData.invoice;
      this.restoreInv.inv_details = JSON.stringify(this.oldData.itemsdetails);


      for (let i = 0; i < invoice_list_arr_new.length; i++) {
        let iserte = {
          value: invoice_list_arr_new[i].account_no, inx: i ,
          statement:invoice_list_arr_new[i].statement ,
          action_year:invoice_list_arr_new[i].action_year ,
          cost_center_id:invoice_list_arr_new[i].cost_center_id ,
          document_type:invoice_list_arr_new[i].document_type ,
          document_no:invoice_list_arr_new[i].document_no ,
          credit:invoice_list_arr_new[i].credit ,
          debit:invoice_list_arr_new[i].debit
        };
        this.Selected_items[i] = iserte;
        this.selectedItem.push(invoice_list_arr_new[i].account_no);
      }
      this.itemCount = Array(this.Selected_items.length).fill(2);
      this.itemCount_old = Array(this.Selected_items.length).fill(2);
      this.changeallremain();
    }
  }

  gridFocus(i: any) {
    let lidx = this.itemCount.lastIndexOf(2);
    if (lidx === i) {
      this.itemCount.push(2);
      const newidx = this.itemCount.lastIndexOf(2);
      const iserte = {value: '',statement:'' , cost_center_id:'' ,document_type:1 ,document_no:'' , credit:0.0,debit:0.0,action_year:this.today};
      this.Selected_items[newidx] = iserte;
    }
  }

  permissionAllow(button: string): boolean {
    let userRoles: any[] = [];
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      userRoles = userdata.roles.description;
    }
    let role: string = '';
    switch (button) {
      case 'newButton': {
        role = 'create';
        break;
      }
      /*  case 'recordDataButton': {
            role = 'recordData';
            break;
        }*/
      case 'saveButton': {
        role = 'update';
        break;
      }
      case 'deleteButton': {
        role = 'delete';
        break;
      }
      case 'searchButton': {
        role = 'search';
        break;
      }
      case 'excelButton': {
        role = 'excel';
        break;
      }
      case 'printButton': {
        role = 'print';
        break;
      }
      case 'historyButton': {
        role = 'history';
        break;
      }
      case 'restoreButton': {
        role = 'restore';
        break;
      }
      case 'attachmentsButton': {
        role = 'attachments';
        break;
      }
      case 'rowinfo': {
        role = 'rowinfo';
        break;
      }

      default: {
        role = '';
        break;
      }
    }
    if (userRoles.indexOf('pos.invoices.' + role) >= 0) {
      return true;
    }
    return false;
  }

  deleteOpeningbalances(invoice: Openingbalances) {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Delete'),
      message: this.translate.instant('Are you sure of delete ?'),
      icon: 'fa fa-trash',
      accept: () => {
        if (invoice) {
          this.invoiceService.delete(invoice.id).subscribe(
            res => {
              this.msgs = [];
              this.msgs.push({
                severity: 'success',
                summary: '',
                detail: this.translate.instant('Delete completed')
              });
              this.router.navigate(['/openingbalances']);
            }
          );
        }
      }
    });
  }

  recoverEdit(invoice: Openingbalances) {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Undo Edit'),
      message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
      icon: 'fa fa-undo',
      accept: () => {
        if (invoice) {
          this.invoiceService.update(invoice).subscribe(
            res => {
              this.msgs = [];
              this.msgs.push({
                severity: 'success',
                summary: '',
                detail: this.translate.instant('Data returned')
              });
              this.activeModal.close('done');
              this.router.navigate(['/openingbalances/show', invoice.id]);
            }
          );
        }
      }
    });
  }

  undotrashed() {
    this.confirmationService.confirm({
      header: this.translate.instant('Confirm Undo Delete'),
      message: this.translate.instant('Are you sure about recover deleted item?'),
      icon: 'fa fa-undo',
      accept: () => {
        if (this.delId) {
          this.invoiceService.restoreTrashedById(this.delId).subscribe(
            res => {
              this.msgs = [];
              this.msgs.push({
                severity: 'success',
                summary: '',
                detail: this.translate.instant('Deleted invoice recovered')
              });
              this.activeModal.dismiss('close click');
              this.router.navigate(['/openingbalances/list']);
            }
          );
        }
      }
    });
  }


  showattachement(row_id: string) {
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }

  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
    }
  }


  changeallremain() {
    this.total_credit = 0.0;
    this.total_debit = 0.0;

    for (let i = 0; i < this.Selected_items.length; i++) {
      if (typeof  this.Selected_items[i] !== "undefined") {
        this.total_credit += parseFloat(this.Selected_items[i].credit);
        this.total_debit += parseFloat(this.Selected_items[i].debit);
      }
    }

    this.total_credit_old = 0.0;
    this.total_debit_old = 0.0;

    for (let i = 0; i < this.Selected_items_old.length; i++) {
      if (typeof  this.Selected_items_old[i] !== "undefined") {
        this.total_credit_old += parseFloat(this.Selected_items_old[i].credit);
        this.total_debit_old += parseFloat(this.Selected_items_old[i].debit);
      }
    }
  }

  changealldiscount() {
    let discv = this.form.controls['disc_value'].value;
    let disct = this.form.controls['disc_type'].value;
    if (disct == 1) {
      this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2);
    } else {
      this.alldiscountvalue = parseFloat(discv).toFixed(2);
    }
    this.changeallremain();
  }

  showAccount(accountNo:string) {
    if(!accountNo) return;

    const options: NgbModalOptions = {

      beforeDismiss: () => {

        return true;
      }
    };
    this.modalRef = this.modalService.open(AccountsShowComponent, options);
    this.modalRef.componentInstance.scrId = accountNo;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {

    });
  }


}



// WEBPACK FOOTER //
// ./src/app/views/fin/openingbalances/openingbalances-show/openingbalances-show.component.ts